import { ACCESS_PACKAGE, type AccessPackageCode } from '@choco-admin/types';

/**
 * Every tier's label, including the ones no longer sold.
 *
 * Display and choice are separate lists on purpose. A distributor already on a
 * retired tier has to read correctly, or the screen shows "Free" for something
 * that is not Free, so every value keeps a label here.
 *
 * Labels are the legacy admin's own (`AccessPackageLabelPropsMap`), which is why
 * `leadGen` reads "Lead Gen".
 */
export const ACCESS_PACKAGE_LABELS: Readonly<
  Record<AccessPackageCode, string>
> = {
  [ACCESS_PACKAGE.FREE]: 'Free',
  [ACCESS_PACKAGE.LEAD_GEN]: 'Lead Gen',
  [ACCESS_PACKAGE.PREMIUM]: 'Premium',
  [ACCESS_PACKAGE.TRIAL]: 'Trial',
  [ACCESS_PACKAGE.VERIFIED]: 'Verified',
};

/**
 * The tiers a distributor can be moved to.
 *
 * Lead Gen, Trial and Verified are not sold any more, so offering them would let
 * someone put a distributor onto a tier nobody maintains. They stay in the labels
 * above, because distributors are still on them.
 */
export const SELECTABLE_ACCESS_PACKAGES: ReadonlyArray<AccessPackageCode> = [
  ACCESS_PACKAGE.FREE,
  ACCESS_PACKAGE.PREMIUM,
];

/** Whether `value` is a tier that can still be chosen. */
export const isSelectableAccessPackage = (value?: string | null): boolean =>
  SELECTABLE_ACCESS_PACKAGES.some((entry) => entry === value);

/** What to show for a stored value, retired tiers included. */
export const accessPackageLabel = (value?: string | null): string =>
  ACCESS_PACKAGE_LABELS[value as AccessPackageCode] ??
  ACCESS_PACKAGE_LABELS[ACCESS_PACKAGE.FREE];
